import React, { useState } from 'react';
import { Formik, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { signup } from '../../lib/authentication';
import eyeVisibleIcon from '../../assets/images/eye-visible.svg';
import eyeHiddenIcon from '../../assets/images/eye-hidden.svg';
import styles from './SignupForm.module.scss';

interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

const initialFormValues: FormValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
};

const validationSchema = yup.object({
  firstName: yup.string().required('Please enter your first name'),
  lastName: yup.string().required('Please enter your last name'),
  email: yup.string().required(`Please enter your email address`),
  password: yup.string().required(`Please enter your password`),
});

export default function SignupForm() {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div>
      <Formik<FormValues>
        onSubmit={async (values, { setSubmitting, setStatus }) => {
          try {
            const firstName = values.firstName.trim();
            const lastName = values.lastName.trim();
            await signup(values.email, values.password, firstName, lastName);
          } catch (err) {
            setStatus({ errorMessage: (err as any).message });
          } finally {
            setSubmitting(false);
          }
        }}
        validationSchema={validationSchema}
        initialValues={initialFormValues}
      >
        {({ handleSubmit, isSubmitting, status, submitForm }) => (
          <form onSubmit={handleSubmit} className="form form__app">
            <div className="form-group">
              <div className="form-field">
                <Field type="text" name="email" placeholder="Email" />
                <ErrorMessage name="email" component="div" className="form-field__error" />
              </div>
            </div>
            <div className="form-group">
              <div className={`form-field ${styles.passwordFieldWrapper}`}>
                <Field
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Password"
                  className={styles.passwordInput}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className={styles.toggleButton}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  <img
                    src={showPassword ? eyeHiddenIcon : eyeVisibleIcon}
                    alt={showPassword ? 'Hide password' : 'Show password'}
                    className={styles.toggleIcon}
                  />
                </button>
                <ErrorMessage name="password" component="div" className="form-field__error" />
              </div>
            </div>
            <div className="form-group">
              <div className="form-field">
                <Field type="text" name="firstName" placeholder="First name" />
              </div>
              <div className="form-field">
                <Field type="text" name="lastName" placeholder="Last name" />
              </div>
            </div>
            <ErrorMessage name="firstName" component="div" className="form-field__error" />
            <ErrorMessage name="lastName" component="div" className="form-field__error" />
            <div className="form-group form-group--action form-group--action__wide">
              <div className="form-field">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn-yellow"
                  onClick={(e) => {
                    e.preventDefault();
                    submitForm();
                  }}
                >
                  Sign Up
                </button>
                {status && status.errorMessage && <div className="form-field__error">{status.errorMessage}</div>}
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}
